import { Injectable } from '@angular/core';
import { HttpClient } from './http-client';
import { Response } from '@angular/http';
import * as moment from 'moment';
import {
  NegociosService,
  ProductoService,
  EntregaService,
  CosechaService,
  MonedaService,
  PreciosService,
} from '../services';
import { TnsPipe, PricePipe } from '../utils/pipes';


export const HISTORY_LIST_ENTITY = {
  NEGOCIO: 'negocio',
  AVISO: 'aviso'
};

export const NEGOCIO_COLUMN_NAME = {
  'Net_ID': 'Tipo',
  'Pro_ID': 'Producto',
  'Ent_ID': 'Negocio',
  'Pos_ID': 'Posicion',
  'Cos_ID': 'Cosecha',
  'Cli_ID': 'Cliente',
  'Aco_ID': 'Acopio',
  'Mon_ID': 'Moneda',
  'Neg_Toneladas': 'Toneladas',
  'Neg_Vencimiento': 'Vencimiento',
  'Neg_Base': 'Base',
  'Neg_Observaciones': 'Observaciones',
  'Mercado_ID': 'Mercado',
};

export const AVISO_COLUMN_NAME = {
  'Cos_ID': 'Cosecha',
  'Nea_Kilos': 'Toneladas'
};

@Injectable()
export class HistoryService {

  constructor(private httpClient: HttpClient,
              private negociosService: NegociosService,
              private productoService: ProductoService,
              private entregaService: EntregaService,
              private cosechaService: CosechaService,
              private monedaService: MonedaService,
              private tnsPipe: TnsPipe,
              private pricePipe: PricePipe,
              private preciosService: PreciosService,
  ) { }

  public getHistory(entity, Id) {
    switch (entity) {
      case HISTORY_LIST_ENTITY.NEGOCIO:
        return this.httpClient.get(`/api/negocio/get-audit-data/${Id}`)
          .map((response: Response) => {
            return response.json().ResponseData;
          });
      case HISTORY_LIST_ENTITY.AVISO:
        return this.httpClient.get(`/api/negocio/get-aviso-audit-data/${Id}`)
          .map((response: Response) => {
            return response.json().ResponseData;
          });
    }
  }

  public setupData(entity, data) {
    const response = [];
    console.log(data);
    data.forEach(x => {
      // obtenemos la lista de detalles a agregar
      // solo se debe mostrar en la lista de cambios, cambios que puedan ser realizados
      // por usuarios o el propio Sistema de Acopios, no cuentan cambios de estado
      // pues estos se detallan en la seccion de actividades

      // Filtramos las columnas que pueden tener valores, agregar cada entidad por cada tabla nueva trackeada
      const details = x.LogDetails.filter(y => NEGOCIO_COLUMN_NAME[y.PropertyName] || AVISO_COLUMN_NAME[y.PropertyName]);
      details.forEach(det => {
        const formattedData = this.setupDataValues(det.OriginalValue, det.NewValue, det.OriginalValueId, det.NewValueId, det.PropertyName, entity);
        response.push({
          UserName: x.User.UserFullName,
          UserId: x.User.UserId,
          // la variable indica UTC, pero el back lo convierte a hora local
          Fecha: moment.unix(x.EventDateUTC).format('DD/MM/YYYY') + ' | ' + moment.unix(x.EventDateUTC).format('HH:mm') + 'hs',
          Columna: NEGOCIO_COLUMN_NAME[det.PropertyName] ||
                   AVISO_COLUMN_NAME[det.PropertyName] || '-',
          Previo: formattedData.OriginalValue,
          PrevioId: formattedData.OriginalValueId,
          Actual: formattedData.NewValue,
          ActualId: formattedData.NewValueId
        });
      });
    });
    console.log(response);
    return response.reverse();
  }

  private setupDataValues(valueOrig, valueNew, valueOrigId, valueNewId, column, entity) {

    // en este método seteamos la data para que sea amigable para el usuario,
    // en caso de que la data no este cacheada en el front (acopio, cliente)
    // no necesita procesarse, devolvemos los valores en el objeto tal cual
    const valueToReturn = {
      OriginalValue: null,
      NewValue: null,
      OriginalValueId: null,
      NewValueId: null
    };

    switch (entity) {

      case HISTORY_LIST_ENTITY.NEGOCIO:

        switch (NEGOCIO_COLUMN_NAME[column]) {
          // Tipo
          case NEGOCIO_COLUMN_NAME.Net_ID:
            const tipos = this.negociosService.getNegocioTipoOptions();
            valueToReturn.OriginalValue = tipos[tipos.findIndex(x => x.ID.toString() === valueOrig)].Tipo_Negocio;
            valueToReturn.NewValue = tipos[tipos.findIndex(x => x.ID.toString() === valueNew)].Tipo_Negocio;
            break;

          // Producto
          case NEGOCIO_COLUMN_NAME.Pro_ID:
            const productos = this.productoService.Options.getValue();
            valueToReturn.OriginalValue = productos[productos.findIndex(x => x.ID.toString() === valueOrig)].Producto;
            valueToReturn.NewValue = productos[productos.findIndex(x => x.ID.toString() === valueNew)].Producto;
            break;

          // Entrega
          // la columan entrega es Negocio, diferenciamos Disponible y Forward
          case NEGOCIO_COLUMN_NAME.Ent_ID:
            const entregas = this.entregaService.Options.getValue();

            const previousLabelNew = valueNew === '1' || valueNew === '2' ? 'Disponible' : 'Forward';
            const _valueNew = entregas[entregas.findIndex(x => x.ID.toString() === valueNew)].Entrega;
            const previousLabelOriginal = valueOrig === '1' || valueOrig === '2' ? 'Disponible' : 'Forward';
            const _valueOrig = entregas[entregas.findIndex(x => x.ID.toString() === valueOrig)].Entrega;
            valueToReturn.OriginalValue = previousLabelOriginal + (_valueOrig !== 'N posiciones' ?  ' - ' + _valueOrig : '');
            valueToReturn.NewValue = previousLabelNew + (_valueNew !== 'N posiciones' ?  ' - ' + _valueNew : '');
            break;

          // Posicion
          case NEGOCIO_COLUMN_NAME.Pos_ID:
            const posiciones = this.entregaService.PosicionOptions.getValue();
            const _posOriginal = valueOrig !== null ? posiciones[posiciones.findIndex(x => x.EsPosicion && x.ID_POS.toString() === valueOrig)].Original : '-';
            valueToReturn.OriginalValue = _posOriginal.charAt(0).toUpperCase() + _posOriginal.slice(1);
            const _posNew = valueNew !== null ? posiciones[posiciones.findIndex(x => x.EsPosicion && x.ID_POS.toString() === valueNew)].Original : '-';
            valueToReturn.NewValue = _posNew.charAt(0).toUpperCase() + _posNew.slice(1);
            break;

          // Cosecha
          case NEGOCIO_COLUMN_NAME.Cos_ID:
            valueToReturn.OriginalValue = this.getCosechaValue(valueOrig);
            valueToReturn.NewValue = this.getCosechaValue(valueNew);
            break;

          // Moneda
          case NEGOCIO_COLUMN_NAME.Mon_ID:
            const monedas = this.monedaService.Options.getValue();
            valueToReturn.OriginalValue = monedas[monedas.findIndex(x => x.ID.toString() === valueOrig)].Moneda;
            valueToReturn.NewValue = monedas[monedas.findIndex(x => x.ID.toString() === valueNew)].Moneda;
            break;

          // Toneladas
          case NEGOCIO_COLUMN_NAME.Neg_Toneladas:
            valueToReturn.OriginalValue = this.tnsPipe.transform(valueOrig.replace(',', '.'));
            valueToReturn.NewValue = this.tnsPipe.transform(valueNew.replace(',', '.'));
            break;

          // Vencimiento
          case NEGOCIO_COLUMN_NAME.Neg_Vencimiento:
            valueToReturn.OriginalValue = valueOrig.split(' ')[0];
            valueToReturn.NewValue = valueNew.split(' ')[0];
            break;

          // Base
          case NEGOCIO_COLUMN_NAME.Neg_Base:
            valueToReturn.OriginalValue = this.pricePipe.transform(this.formatNumber(valueOrig), 'fill');
            valueToReturn.NewValue = this.pricePipe.transform(this.formatNumber(valueNew), 'fill');
            break;

          // Mercado
          case NEGOCIO_COLUMN_NAME.Mercado_ID:
            valueToReturn.OriginalValue = this.getMercadoValue(valueOrig);
            valueToReturn.NewValue = this.getMercadoValue(valueNew);
            break;

          // A partir de aqui colocamos las columnas que no necesitan procesamiento
          case NEGOCIO_COLUMN_NAME.Neg_Observaciones:
          case NEGOCIO_COLUMN_NAME.Aco_ID: // Acopio
          case NEGOCIO_COLUMN_NAME.Cli_ID: // Cliente
            valueToReturn.OriginalValue = valueOrig;
            valueToReturn.NewValue = valueNew;
            valueToReturn.OriginalValueId = valueOrigId;
            valueToReturn.NewValueId = valueNewId;
        }
        break;

      case HISTORY_LIST_ENTITY.AVISO:
        switch (AVISO_COLUMN_NAME[column]) {

          // Cosecha
          case AVISO_COLUMN_NAME.Cos_ID:
            valueToReturn.OriginalValue = this.getCosechaValue(valueOrig);
            valueToReturn.NewValue = this.getCosechaValue(valueNew);
            break;

          // Toneladas
          case AVISO_COLUMN_NAME.Nea_Kilos:
            valueToReturn.OriginalValue = this.tnsPipe.transform(Number.parseFloat(valueOrig.replace(',', '.')) / 1000);
            valueToReturn.NewValue = this.tnsPipe.transform(Number.parseFloat(valueNew.replace(',', '.')) / 1000);
            break;
        }
        break;

    }

    return valueToReturn;
  }

  formatNumber(num) {
    // el back es irregular y en ocasiones devuelve valores con decimal cero y a veces enteros...
    const arr = num.split(',');
    if (arr[1]) {
      if (Number.parseInt(arr[1], 10) !== 0) {
        return arr[0] + '.' + Number.parseInt(arr[1], 10).toString();
      }
    }
    return arr[0];
  }

  getCosechaValue(value) {
    const cosechas = this.cosechaService.Options.getValue();
    return cosechas[cosechas.findIndex(x => x.ID.toString() === value)].Cosecha;
  }

  getMercadoValue(value) {
    if (this.preciosService.mercadosSource.value && this.preciosService.mercadosSource.value.length) {
      return this.preciosService.mercadosSource.value.find(x => x.Id.toString() === value).Mercado;
    }
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/services/history-service.ts